import axios from "axios";
export const folderNames = {
  property : {
    main:"properties/main",
    bedrooms: "properties/bedrooms"
  },
  docs:{
    extracharge:'doc/extracharge',
    evictmember:'doc/extracharge',
    disputes:'doc/disputes'
  }
}

export function imageUpload(formData) {
  return axios
    .post(process.env.VUE_APP_CLOUDINARY_URL, formData)
    .then(data => {
      return data;
    })
    .catch(err => {
      return err;
    });
}
export async function uploadFile(file, folderName) {
  const preset = process.env.VUE_APP_CLOUDINARY_PRESET;
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", preset);
  if(folderName){
    formData.append("folder", folderName);
  }
  return axios
    .post(process.env.VUE_APP_CLOUDINARY_URL, formData)
    .then(data => {
      return data;
    })
    .catch(err => {
      return err;
    });
}



//////////////////
// WEBPACK FOOTER
// ./services/fileUpload.js
// module id = null
// module chunks = 